import mutations from './mutations'
const apiEndpoint = 'settings'
import settingsApi from '../../api/settings'

export default {
  namespaced: true,

  state: {
    globalSettings: [],
    settings: []
  },

  actions: {
    async loadGlobalSettings ({ state, commit }) {
        const settings = await settingsApi.getGlobalSettings()
        commit('setGlobalSettings', settings.data.items)
        return settings.data.items
    },
  },

  mutations: {
    ...mutations,
    setGlobalSettings(state, newSettings) {
        state.globalSettings = newSettings
    },
  }
}
